import {FieldErrors} from "react-hook-form";

import {IAppError} from "@pg-mono/request-state";

import {IAmplitudeLeadFormTrackingContext} from "../../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/form/application_form_source";
import {collectLeadFormFieldErrorPaths} from "./collect_lead_form_field_error_paths";
import {getAmplitudeFormLocation} from "./get_amplitude_form_location";
import {getAmplitudeInquirySource} from "./get_amplitude_inquiry_source";
import {getAmplitudeLeadFormProducts, IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";
import {getAmplitudeLeadType} from "./get_amplitude_lead_type";

interface IAmplitudeLeadFormErrorBaseParams {
    trackingContext: IAmplitudeLeadFormTrackingContext;
    leadData: IAmplitudeLeadFormProductData | IAmplitudeLeadFormProductData[] | undefined;
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    /** Overrides the CTA that opened the form; `null` reports no CTA click (validation surfaced while typing). */
    ctaText?: string | null;
}

export type IGetAmplitudeLeadFormErrorEventPropertiesParams = IAmplitudeLeadFormErrorBaseParams &
    ({appError: IAppError; errorCode?: string; fieldErrors?: never} | {fieldErrors: FieldErrors; appError?: never; errorCode?: never});

const buildErrorMessage = (appError: IAppError, errorCode: string): string => {
    const fieldMessages = Object.values(appError.fieldErrors).flat();
    const parts = [...fieldMessages, ...appError.nonFieldErrors].filter(Boolean);

    // Server failures often surface nothing to the user; report the code so the event is still readable.
    return parts.length > 0 ? parts.join("; ") : errorCode;
};

/**
 * Only a 400 carries per-field validation feedback; everything else is a server-side failure.
 * Presence of `fieldErrors` must NOT decide this — `getAppErrors` files every top-level response key
 * under `fieldErrors`, so a 5xx body like `{"detail": "..."}` would otherwise report as validation.
 */
export const getAmplitudeLeadFormErrorType = (appError: IAppError): "validation" | "server" => (appError.status === 400 ? "validation" : "server");

const getAmplitudeLeadFormErrorSharedProperties = (params: IAmplitudeLeadFormErrorBaseParams) => {
    const {trackingContext, leadData, source, sourceSection, ctaText} = params;
    const products = getAmplitudeLeadFormProducts(leadData);
    const primaryLeadData = Array.isArray(leadData) ? leadData[0] : leadData;
    const resolvedCtaText = ctaText !== undefined ? ctaText : trackingContext.cta_text;

    return {
        inquiry_source: getAmplitudeInquirySource(source),
        cta_text: resolvedCtaText || null,
        form_location: getAmplitudeFormLocation(primaryLeadData, trackingContext.form_location),
        source_id: trackingContext.source_id,
        lead_type: getAmplitudeLeadType(sourceSection),
        products,
        ...(trackingContext.promotion_id != null && {promotion_id: trackingContext.promotion_id}),
        ...(trackingContext.creative_name && {creative_name: trackingContext.creative_name}),
        ...(trackingContext.promotion_name && {promotion_name: trackingContext.promotion_name}),
        ...(trackingContext.promotion_content && {promotion_content: trackingContext.promotion_content}),
        ...(trackingContext.auth_placement !== undefined && {auth_placement: trackingContext.auth_placement}),
        ...(trackingContext.rp_search_stage != null && {rp_search_stage: trackingContext.rp_search_stage}),
        ...trackingContext.additionalEventProperties
    };
};

export const getAmplitudeLeadFormErrorEventProperties = (params: IGetAmplitudeLeadFormErrorEventPropertiesParams) => {
    const shared = getAmplitudeLeadFormErrorSharedProperties(params);

    if (params.appError) {
        const errorCode = params.errorCode ?? String(params.appError.status);
        const errorType = getAmplitudeLeadFormErrorType(params.appError);
        // Server responses put arbitrary keys (`detail`, list indexes) in `fieldErrors`; those are not
        // form fields, so only a validation failure reports them.
        const fieldErrorNames = errorType === "validation" ? Object.keys(params.appError.fieldErrors) : [];

        return {
            ...shared,
            error_type: errorType,
            error_message: buildErrorMessage(params.appError, errorCode),
            error_fields: fieldErrorNames.length > 0 ? fieldErrorNames : null,
            error_code: errorCode
        };
    }

    const {errorFields, errorMessages} = collectLeadFormFieldErrorPaths(params.fieldErrors);

    return {
        ...shared,
        error_type: "validation" as const,
        error_message: errorMessages.length > 0 ? errorMessages.join("; ") : "validation failed",
        error_fields: errorFields.length > 0 ? errorFields : null,
        error_code: "validation"
    };
};
import {FieldErrors} from "react-hook-form";

import {IAppError} from "@pg-mono/request-state";

import {IAmplitudeLeadFormTrackingContext} from "../../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/form/application_form_source";
import {collectLeadFormFieldErrorPaths} from "./collect_lead_form_field_error_paths";
import {getAmplitudeFormLocation} from "./get_amplitude_form_location";
import {getAmplitudeInquirySource} from "./get_amplitude_inquiry_source";
import {getAmplitudeLeadFormProducts, IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";
import {getAmplitudeLeadType} from "./get_amplitude_lead_type";

interface IAmplitudeLeadFormErrorBaseParams {
    trackingContext: IAmplitudeLeadFormTrackingContext;
    leadData: IAmplitudeLeadFormProductData | IAmplitudeLeadFormProductData[] | undefined;
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    /** Overrides the CTA that opened the form; `null` reports no CTA click (validation surfaced while typing). */
    ctaText?: string | null;
}

export type IGetAmplitudeLeadFormErrorEventPropertiesParams = IAmplitudeLeadFormErrorBaseParams &
    ({appError: IAppError; errorCode?: string; fieldErrors?: never} | {fieldErrors: FieldErrors; appError?: never; errorCode?: never});

const buildErrorMessage = (appError: IAppError, errorCode: string): string => {
    const fieldMessages = Object.values(appError.fieldErrors).flat();
    const parts = [...fieldMessages, ...appError.nonFieldErrors].filter(Boolean);

    // Server failures often surface nothing to the user; report the code so the event is still readable.
    return parts.length > 0 ? parts.join("; ") : errorCode;
};

/**
 * Only a 400 carries per-field validation feedback; everything else is a server-side failure.
 * Presence of `fieldErrors` must NOT decide this — `getAppErrors` files every top-level response key
 * under `fieldErrors`, so a 5xx body like `{"detail": "..."}` would otherwise report as validation.
 */
export const getAmplitudeLeadFormErrorType = (appError: IAppError): "validation" | "server" => (appError.status === 400 ? "validation" : "server");

const getAmplitudeLeadFormErrorSharedProperties = (params: IAmplitudeLeadFormErrorBaseParams) => {
    const {trackingContext, leadData, source, sourceSection, ctaText} = params;
    const products = getAmplitudeLeadFormProducts(leadData);
    const primaryLeadData = Array.isArray(leadData) ? leadData[0] : leadData;
    const resolvedCtaText = ctaText !== undefined ? ctaText : trackingContext.cta_text;

    return {
        inquiry_source: getAmplitudeInquirySource(source),
        cta_text: resolvedCtaText || null,
        form_location: getAmplitudeFormLocation(primaryLeadData, trackingContext.form_location),
        source_id: trackingContext.source_id,
        lead_type: getAmplitudeLeadType(sourceSection),
        products,
        ...(trackingContext.promotion_id != null && {promotion_id: trackingContext.promotion_id}),
        ...(trackingContext.creative_name && {creative_name: trackingContext.creative_name}),
        ...(trackingContext.promotion_name && {promotion_name: trackingContext.promotion_name}),
        ...(trackingContext.promotion_content && {promotion_content: trackingContext.promotion_content}),
        ...(trackingContext.auth_placement !== undefined && {auth_placement: trackingContext.auth_placement}),
        ...(trackingContext.rp_search_stage != null && {rp_search_stage: trackingContext.rp_search_stage}),
        ...trackingContext.additionalEventProperties
    };
};

export const getAmplitudeLeadFormErrorEventProperties = (params: IGetAmplitudeLeadFormErrorEventPropertiesParams) => {
    const shared = getAmplitudeLeadFormErrorSharedProperties(params);

    if (params.appError) {
        const errorCode = params.errorCode ?? String(params.appError.status);
        const errorType = getAmplitudeLeadFormErrorType(params.appError);
        // Server responses put arbitrary keys (`detail`, list indexes) in `fieldErrors`; those are not
        // form fields, so only a validation failure reports them.
        const fieldErrorNames = errorType === "validation" ? Object.keys(params.appError.fieldErrors) : [];

        return {
            ...shared,
            error_type: errorType,
            error_message: buildErrorMessage(params.appError, errorCode),
            error_fields: fieldErrorNames.length > 0 ? fieldErrorNames : null,
            error_code: errorCode
        };
    }

    const {errorFields, errorMessages} = collectLeadFormFieldErrorPaths(params.fieldErrors);

    return {
        ...shared,
        error_type: "validation" as const,
        error_message: errorMessages.length > 0 ? errorMessages.join("; ") : "validation failed",
        error_fields: errorFields.length > 0 ? errorFields : null,
        error_code: "validation"
    };
};
